var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKgRejectedCase(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 69,
    height: 70,
    viewBox: "0 0 69 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.114258,
    y: 0.664062,
    width: 68.6176,
    height: 68.6176,
    rx: 9.80251,
    fill: "#DFFFF9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.4235 23.21C35.8101 23.21 37.1399 23.7608 38.1203 24.7412C39.1007 25.7216 39.6515 27.0514 39.6515 28.438C39.6515 29.3921 39.4032 30.2808 38.9458 31.052H42.2655C43.5072 31.052 44.5528 31.9277 44.8142 33.0909C47.4413 43.56 47.4936 43.8344 47.4936 44.122C47.4936 44.8153 47.2181 45.4801 46.7279 45.9704C46.2377 46.4606 45.5728 46.736 44.8795 46.736H23.9675C23.2742 46.736 22.6094 46.4606 22.1191 45.9704C21.6289 45.4801 21.3535 44.8153 21.3535 44.122C21.3535 43.8344 21.4058 43.56 24.0329 33.0909C24.2943 31.9277 25.3399 31.052 26.5815 31.052H29.9013C29.4347 30.2602 29.1908 29.357 29.1955 28.438C29.1955 27.0514 29.7463 25.7216 30.7268 24.7412C31.7072 23.7608 33.037 23.21 34.4235 23.21ZM34.4235 25.824C33.7303 25.824 33.0654 26.0994 32.5752 26.5896C32.0849 27.0798 31.8095 27.7447 31.8095 28.438C31.8095 29.1312 32.0849 29.7961 32.5752 30.2863C33.0654 30.7766 33.7303 31.052 34.4235 31.052C35.1168 31.052 35.7817 30.7766 36.2719 30.2863C36.7621 29.7961 37.0375 29.1312 37.0375 28.438C37.0375 27.7447 36.7621 27.0798 36.2719 26.5896C35.7817 26.0994 35.1168 25.824 34.4235 25.824ZM26.5815 33.666V44.122H29.1955V40.8545L30.5025 42.1615V44.122H33.1165V41.508L30.5025 38.894L33.1165 36.28V33.666H30.5025V35.6265L29.1955 36.9335V33.666H26.5815ZM38.3445 33.666C36.8938 33.666 35.7305 34.8292 35.7305 36.28V41.508C35.7305 42.9588 36.8938 44.122 38.3445 44.122H42.2655V37.587H39.6515V41.508H38.3445V36.28H42.2655V33.666H38.3445Z",
    fill: "#25AA91"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKgRejectedCase);
export default __webpack_public_path__ + "static/media/kg_rejected_case.ba57bea10c03564d1cd9394bed4a696a.svg";
export { ForwardRef as ReactComponent };